// eslint-disable-next-line no-useless-escape
const REGEXP = /([\.$?*|{}\(\)\[\]\\\/\+^])/g;

export const getCookie = (name: string) => {
  const matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(REGEXP, '\\$1') + '=([^;]*)')
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
